/**
 * URL-param compat shim — rewrites legacy `?lens=X` to `?mode=X`.
 *
 * Cycle 101 sprint-2 Task 2.9. lens→mode rename compat path per SDD §5.1
 * (D-101-7) + master §Lens→mode rename. Shim is indefinite until <0.1%
 * `?lens=` hits in rolling 14d (sprint.md AC-3).
 *
 * lens-deprecated — this hook is the only surviving site that references
 * the legacy `"lens"` URL param. Its counterpart test at
 * `__tests__/useLensParamShim.test.tsx` is the second allowed site.
 * `grep -rn '\blens\b' frontend/src` should return only these two files.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useLensParamShim(): void {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // lens-deprecated
    const legacyValue = searchParams.get('lens');
    if (legacyValue === null) return;

    const next = new URLSearchParams(searchParams);
    // lens-deprecated
    next.delete('lens');
    // Don't overwrite a caller-supplied `mode` — `mode` wins on conflict.
    if (!next.has('mode')) {
      next.set('mode', legacyValue);
    }
    setSearchParams(next, { replace: true });

    console.warn(
      'deprecation_warning: ?lens=<value> rewritten to ?mode=<value>. ' +
        'Update callers; shim is Cycle 101 sprint-2 compat per SDD §5.1.'
    );
  }, [searchParams, setSearchParams]);
}
